<template lang="pug">
  transition(name="fade")
    div.SearchAttributesGroup(
      v-show="hasFacets"
      :class="(hasRefinedFacets || hasRefinedTreeFacets ? ' is-refining' : '')+(listOpened ? ' is-open' : '')"
    )
      p.SearchAttributesGroup_title(@click="toggle")
        span.SearchAttributesGroup_titleLabel {{ label }}
      transition(
        v-on:enter="openList"
        v-on:leave="closeList"
      )
        .SearchAttributesGroup_listContainer(v-show="listOpened")
          //- ais-tree-menu(:attributes="group.tree" v-if="group.tree")
          ais-tree-menu(
            ref="tree"
            :attribute="(group.name)"
            :attributes="group.tree"
            :classNames="{'ais-tree-menu__item': 'SearchAttributesSubGroup', 'ais-tree-menu__value': 'SearchAttributesGroup_titleLabel', 'ais-tree-menu__count': 'SearchAttributesGroup_none', 'ais-tree-menu__list': 'SearchAttributesSubGroup_list'}"
            v-if="group.tree"
            @click.native='treeUpdated')
          SearchRefinementList(
            :attribute-name="name"
            ref="list"
            operator="or"
            :limit="5"
            :sortBy="['name:asc']"
            :groupName="name"
            v-else)
</template>

<script>
import { Component } from 'vue-instantsearch'
import SearchRefinementList from '@/components/SearchRefinementList'
import SearchTreeMenu from '@/components/SearchTreeMenu'
import { TweenLite } from 'gsap'

export default {
  mixins: [Component],
  components: { SearchTreeMenu, SearchRefinementList },
  props: ['label', 'name', 'group'],
  data () {
    return {
      listOpened: false,
      isAnimating: false,
      isRefining: false,
      hasRefinedTreeFacets: false
    }
  },
  updated () {
    const treeMenuLabel = document.querySelectorAll(
      '.SearchAttributesGroup_titleLabel'
    )

    for (const items of treeMenuLabel) {
      if (items.innerHTML.includes('%')) {
        items.innerHTML = items.innerHTML.replace(/%.*%/, '')
      }
    }
  },
  computed: {
    facetValues () {
      return this.searchStore.getFacetValues(this.name)
    },
    hasFacets () {
      if (this.$refs.tree) return this.$refs.tree.facetValues.length > 0
      return this.facetValues.length > 0
    },
    hasRefinedFacets () {
      if (this.$refs.tree) {
        return (
          this.$refs.tree.facetValues.filter((facet) => facet.isRefined)
            .length > 0
        )
      } else {
        return this.facetValues.filter((facet) => facet.isRefined).length > 0
      }
    }
  },
  methods: {
    facetValuesByName (name) {
      return this.searchStore.getFacetValues(name)
    },
    treeUpdated () {
      setTimeout(() => {
        this.hasRefinedTreeFacets =
          this.$refs.tree.$el.querySelectorAll('.ais-tree-menu__item--active')
            .length > 0
      }, 300)
    },
    toggle () {
      this.listOpened = !this.listOpened
    },
    /**
     * Recupère la hauteur réelle de la list
     * @return {Number} hauteur de la liste
     */
    getListHeight () {
      const list = this.$refs.list || this.$refs.tree
      return list && list.$el ? list.$el.getBoundingClientRect().height : 0
    },
    /**
     * Animation d'apparition de la liste
     * @param  {HTMLElement} el - élément html de la list
     * @param  {Function} done - callback A APELLER une fois que l'animation est finie
     */
    openList (el, done) {
      // Seulement si on n'est pas déjà en train d'animer
      if (!this.isAnimating) {
        // On défini l'état de base (caché)
        TweenLite.set(el, {
          height: 0,
          opacity: 0,
          onComplete: () => {
            this.isAnimating = false
            done()
          }
        })
      }

      this.isAnimating = true

      TweenLite.to(el, 0.8, {
        height: this.getListHeight(),
        opacity: 1,
        clearProps: 'opacity,height' // enlève les propriétés une fois l'animation terminée (principalement pour le responsive)
      })
    },
    /**
     * Animation de disparition de la liste
     * @param  {HTMLElement} el - élément html de la list
     * @param  {Function} done - callback A APELLER une fois que l'animation est finie
     */
    closeList (el, done) {
      this.isAnimating = true

      TweenLite.to(el, 0.5, {
        height: 0,
        opacity: 0,
        onComplete: () => {
          this.isAnimating = false
          done()
        }
      })
    }
  }
}
</script>

<style lang="stylus">

.SearchAttributesGroup,
.SearchAttributesSubGroup
  margin-top -1px // HACK - comme ça on boit qu'une seule des 2 bordures lorsque 2 éléments se suivent

  &:hover

    .SearchAttributesGroup_title:before, .SearchAttributesGroup_titleLabel

      opacity 1

  &.is-refining
    .SearchAttributesGroup_title
      &::before
        background-color $beige

    .SearchAttributesGroup_titleLabel
      opacity: 1

  &.is-open
    .SearchAttributesGroup_title
      &::after
        opacity 1
        transform: translate(0,-50%) rotateZ(180deg)

  &_title
    position: relative
    cursor: pointer
    height 50px
    display: flex
    flex-direction row
    justify-content: flex-start
    align-items: center
    color $beige
    text-transform: uppercase
    font-size 1rem
    line-height 1rem
    border-width 1px 0 1px
    border-color $black
    border-style solid
    padding-right 20px

    // circle
    &::before
      content ''
      display: inline-block
      width 18px
      min-width 18px
      height: @width
      border-radius (@width/2)
      border 1px solid $beige
      margin 0 10px
      opacity .3
      transition all .8s $ease

    // triangle
    &::after
      content ''
      display block
      position absolute
      top 50%
      right 10px
      width: 0
      height: 0
      border-style: solid
      border-width: 0 4px 6px 4px
      border-color: transparent transparent $beige transparent
      transform: translate(0,-50%) rotateZ(360deg)
      transition transform .8s $ease
      opacity .5

  &_titleLabel
    opacity .5
    transition opacity .8s $ease
    letter-spacing 0
    text-align left
    font-weight normal
    font-size 1rem
    line-height 1rem
    transition all 0.8s $ease

  &_listContainer
    overflow hidden

  &_none

    display none

.SearchAttributesSubGroup

  display block
  padding 0px

  &_list

    width 100%
    padding: 0px
    margin: 0px

  a

    position: relative
    cursor: pointer
    height 50px
    display: flex
    flex-direction row
    justify-content: flex-start
    align-items: center
    color $beige
    text-transform: uppercase
    font-size 1rem
    line-height 1rem
    border-width 1px 0 1px
    border-color $black
    border-style solid
    font-weight normal
    text-decoration none
    padding-left 25px

    // circle
    &::before
      content ''
      display: inline-block
      width 18px
      min-width 18px
      height: @width
      border-radius (@width/2)
      border 1px solid $beige
      margin 0 10px
      opacity .3
      transition all .8s $ease

  &:hover

    .SearchAttributesGroup_titleLabel

      letter-spacing 1.4px

  &.ais-tree-menu__item--active

    & > a
      &::before
        background-color $beige

  & > ul

    display block
    width 100%
    padding 0px

    & > li

      a

        padding-left 50px

      & > ul

        & > li

          a

            padding-left 75px

          & > ul

            & > li

              a

                padding-left 85px

</style>
